import {translations} from '@common/translations';
import {useLocale} from '@common/hooks/useLocale';

export const useTranslation: (field: string) => any = (field) => {
  const locale = useLocale()

  //@ts-ignore
  return locale === 'ru' ? translations.ru[field] : translations.en[field]
}
